import type { ReactNode } from 'react';
import { cn } from '@/utils/tailwind.util';
interface SettingSectionProps {
  /** 섹션 머리말. Figma `Section title` */
  title: string;
  children: ReactNode;
  className?: string;
}

/**
 * 설정 화면의 카드 한 장 (제목 + 본문).
 *
 * 퀴즈 제작(`BuildStepSettings`)에서 쓰던 지역 컴포넌트를 그대로 끌어올린 것이다.
 * 컬렉션 수정 화면(Figma 32600:249085)이 **같은 셸을 픽셀 단위로 재사용**하는데,
 * 그 화면은 빌드 폼(`useBuildFormContext`)과 아무 관계가 없어서 빌드 안에 둘 수 없었다.
 *
 * 도메인을 모른다 — 폼 바인딩은 전부 children 쪽 몫이다.
 */
export const SettingSection = ({
  title,
  children,
  className
}: SettingSectionProps) => {
  return <div className={cn('bg-default p-xl rounded-md border border-assistive', className)} data-sentry-component="SettingSection" data-sentry-source-file="SettingSection.tsx">
      <h3 className={'mb-lg text-body-md-bold text-assistive'}>{title}</h3>
      <div className={'flex flex-col gap-lg'}>{children}</div>
    </div>;
};